@if (templateData(); as templateData) {
  <!--
    Event delegation: click/keydown handlers intercept events from focusable anchor tags
    inside the innerHTML. The container div itself does not need to be focusable.
  -->
  <!-- eslint-disable-next-line @angular-eslint/template/interactive-supports-focus -->
  <div
    class="drimify-text-rich"
    [class]="templateData.classType"
    [attr.aria-label]="templateData.ariaLabel || null"
    [attr.role]="templateData.role || 'presentation'"
    (click)="onRichTextClick($event)"
    (keydown)="onRichTextKeydown($event)"
  >
    <div [innerHTML]="templateData.data | safeHtml"></div>
  </div>
}
